import axios from "axios";
import { baseUrl } from "../../services";
import { getAccessToken } from "../../services/tokenStore";

class BackendUploadAdapter {
  constructor(loader) {
    this.loader = loader;
  }

  upload() {
    return this.loader.file.then(
      (file) =>
        new Promise((resolve, reject) => {
          const formData = new FormData();
          formData.append("file", file);

          const token = getAccessToken();

          axios
            .post(`${baseUrl}upload/image`, formData, {
              headers: {
                "Content-Type": "multipart/form-data",
                ...(token && {
                  Authorization: `Bearer ${token}`,
                }),
              },
            })
            .then((response) => {
              const url = response?.data?.url;
              if (url) {
                resolve({ default: url });
              } else {
                reject(new Error("Upload failed"));
              }
            })
            .catch(reject);
        }),
    );
  }

  abort() {}
}

export function UploadAdapterPlugin(editor) {
  editor.plugins.get("FileRepository").createUploadAdapter = (loader) =>
    new BackendUploadAdapter(loader);
}
